import React, { useState } from "react";
import { PROJECTS } from "../mock";
import { Eye, ArrowUpRight } from "lucide-react";

const FILTERS = ["All", "Metal Roofing", "False Ceiling", "Acoustic Ceiling", "Baffle Ceiling", "Clip In Type Suspended Ceiling", "Lay In Type Suspended Ceiling", "84R Type Suspended Ceiling", "84C Type Suspended Ceiling", "False/Cavity Floor", "Insulation", "Cladding"];

function matchFilter(cat, f) {
  if (f === "All") return true;
  return cat.toLowerCase().includes(f.toLowerCase());
}

export default function Projects() {
  const [active, setActive] = useState("All");
  const list = PROJECTS.filter((p) => matchFilter(p.category, active));

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-700">Our Portfolio</div>
          <h2 className="display section-underline center mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 uppercase">
            Recent Projects
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            A snapshot of facade, ceiling, flooring and fenestration work delivered across India.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
          {FILTERS.map((f) => (
            <button
              key={f}
              onClick={() => setActive(f)}
              className={`px-4 py-2 text-sm font-semibold rounded-full border transition-all ${
                active === f
                  ? "bg-slate-900 text-white border-slate-900"
                  : "bg-white text-slate-700 border-slate-200 hover:border-yellow-600 hover:text-yellow-700"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p) => (
            <article key={p.id} className="project-card relative group overflow-hidden rounded-xl bg-slate-100">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end text-white">
                <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-yellow-500">{p.category}</div>
                <h3 className="display mt-1 text-2xl font-bold">{p.title}</h3>
              </div>
              <button className="absolute top-4 right-4 w-10 h-10 rounded-full bg-yellow-700 grid place-items-center text-white opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
                <ArrowUpRight className="w-5 h-5" />
              </button>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <div className="mt-12 text-center text-slate-500">No projects in this category yet.</div>
        )}
      </div>
    </section>
  );
}
